import { render, staticRenderFns } from "./GMakingMoney.vue?vue&type=template&id=666c2c44&scoped=true&"
import script from "./GMakingMoney.vue?vue&type=script&lang=js&"
export * from "./GMakingMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c2c44",
  null
  
)

export default component.exports